var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSzInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.5529 24 24 18.5647 24 12C24 5.44706 18.5412 0 11.9882 0C5.42353 0 0 5.44706 0 12C0 18.5647 5.43529 24 12 24ZM12 22C6.44701 22 2.01172 17.5529 2.01172 12C2.01172 6.45882 6.43525 2 11.9882 2C17.5294 2 21.9882 6.45882 22 12C22.0117 17.5529 17.5411 22 12 22ZM11.8942 7.8118C12.753 7.8118 13.4236 7.12945 13.4236 6.28239C13.4236 5.42356 12.753 4.74121 11.8942 4.74121C11.0353 4.74121 10.3647 5.42356 10.3647 6.28239C10.3647 7.12945 11.0353 7.8118 11.8942 7.8118ZM9.92958 18.4705C9.45899 18.4705 9.08252 18.1293 9.08252 17.647C9.08252 17.1881 9.45899 16.8234 9.92958 16.8234H11.4002V11.4234H10.1296C9.65899 11.4234 9.28252 11.0822 9.28252 10.5999C9.28252 10.1411 9.65899 9.77637 10.1296 9.77637H12.3531C12.9413 9.77637 13.2708 10.1999 13.2708 10.8352V16.8234H14.7296C15.2119 16.8234 15.5884 17.1881 15.5884 17.647C15.5884 18.1293 15.2119 18.4705 14.7296 18.4705H9.92958Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzInfoIcon);
export default __webpack_public_path__ + "static/media/szInfoIcon.96dc88650a82c63bfa5e9846db29b7cb.svg";
export { ForwardRef as ReactComponent };